import { B2BFingerSize } from '../interfaces/b2b-finger-size';
import { ConfiguredItem } from '../interfaces/configured-item';
import { Material } from '../interfaces/material';
import { assert } from './assert.util';

export function getConfiguredItemValue(configuredItem: ConfiguredItem, key: string) {
  const nameKeys = ['form', 'primaryMaterial', 'secondaryMaterial'];
  const val = configuredItem[key as keyof(ConfiguredItem)];
  if (nameKeys.includes(key)) {
    return (val as any)?.shortName ?? null;
  }

  if (key === 'design') {
    return (val as any)?.shortName ?? null;
  }

  return val;
}

export function getConfiguredItemDisplayableValue(configuredItem: ConfiguredItem, key: string) {
  const nameKeys = ['form', 'primaryMaterial', 'secondaryMaterial'];
  const val = configuredItem[key as keyof(ConfiguredItem)];
  if (nameKeys.includes(key)) {
    return (val as any)?.displayName ?? null;
  }

  if (key === 'design') {
    return (val as any)?.displayName ?? null;
  }

  return val;
}

export function getConfiguredItemShortValue(configuredItem: ConfiguredItem, key: string) {
  const nameKeys = ['form', 'primaryMaterial', 'secondaryMaterial'];
  const val = configuredItem[key as keyof(ConfiguredItem)];
  if (nameKeys.includes(key)) {
    return (val as any)?.shortName ?? null;
  }

  if (key === 'design') {
    return (val as any)?.shortName ?? null;
  }

  return val;
}

export function doesMaterialSupportBP(material: Material) {
  const doesShortNameSupportBP = !['TA', 'GBKT'].includes(material.shortName.toUpperCase());
  const doesDisplayNameSupportBP = !material.displayName.toLowerCase().includes('titanium');
  return doesShortNameSupportBP && doesDisplayNameSupportBP;
}

export function formatFingerSizeForSKU(sizeInput: B2BFingerSize | number) {
  const size = typeof(sizeInput) === 'number' ? sizeInput : sizeInput.size;
  if (size >= 10) {
    const sizeStr = size.toString().replace('.', '');
    return sizeStr.length > 2 ? sizeStr : `${sizeStr}0`;
  }
  const sizeStr = size.toString().replace('.', '');
  return `0${sizeStr}`;
}

export function formatFingerSizeForB2BSKU(sizeInput: B2BFingerSize | number) {
  const size = typeof(sizeInput) === 'number' ? sizeInput : sizeInput.size;
  if (size >= 10) {
    const sizeStr = size.toString().replace('.', '');
    return sizeStr.length > 2 ? sizeStr : `${sizeStr}0`;
  }
  const sizeStr = size.toString().replace('.', '');
  if (sizeStr.length === 1) {
    return `0${sizeStr}0`;
  }
  return `0${sizeStr}`;
}
